<template>
	<div class="privacy-policy min-h-screen bg-gray-50 py-4 sm:py-8 px-4">
		<div class="privacy-policy-body max-w-4xl mx-auto bg-white shadow-sm sm:shadow-md rounded-lg p-4 sm:p-6 md:p-8">
			<!-- 标题区域 -->
			<div class="mb-8">
				<h1 class="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-4 sm:mb-6">“{{ APP_DISPLAY_NAME }}”算法备案公示说明</h1>
				<div class="text-gray-700 leading-relaxed text-sm sm:text-base bg-blue-50 border border-blue-100 rounded-lg p-4 sm:p-6">
					<p class="mb-4">
						为依法保障用户对{{ APP_DISPLAY_NAME }}算法服务的基本原理、目的意图和主要运行机制等的知情权，告知用户{{ APP_DISPLAY_NAME }}提供的算法服务的备案情况，我们制定本《“{{ APP_DISPLAY_NAME }}”算法备案公示说明》。
					</p>
					<p>本说明旨在帮助用户了解在使用{{ APP_DISPLAY_NAME }}产品和服务的过程中，我们如何通过算法技术向用户提供信息和服务，充分保障用户的合法权益。</p>
				</div>
			</div>

			<!-- 大模型核心板块 -->
			<div class="mb-8 sm:mb-12">
				<div class="flex items-center mb-4 sm:mb-6">
					<div class="w-1 h-8 sm:h-10 bg-blue-600 rounded-full mr-3 sm:mr-4"></div>
					<h2 class="text-lg sm:text-xl md:text-2xl font-bold text-gray-900">一、大模型</h2>
				</div>

				<!-- 通义千问大模型 -->
				<div class="mb-8 sm:mb-10 bg-white border border-gray-200 rounded-lg sm:rounded-xl overflow-hidden">
					<!-- 模型标题栏 -->
					<div class="bg-gradient-to-r from-blue-50 to-indigo-50 border-b border-gray-200 px-4 sm:px-6 py-4">
						<div class="flex items-start">
							<div>
								<h3 class="text-base sm:text-lg md:text-xl font-bold text-gray-900 mb-1">1. 模型名称：通义千问大模型</h3>
							</div>
						</div>
					</div>

					<!-- 模型内容区域 -->
					<div class="p-4 sm:p-6 space-y-6 sm:space-y-8">
						<!-- 算法名称 -->
						<div>
							<h4 class="text-sm sm:text-base font-semibold text-gray-800 mb-2 pl-1 border-l-3 border-blue-500 pl-3">1.1 核心算法名称</h4>
							<p class="text-gray-700 text-sm sm:text-base ml-4 sm:ml-6 p-3 bg-gray-50 rounded-lg border border-gray-100">达摩院交互式多能型合成算法</p>
						</div>

						<!-- 算法类型 -->
						<div>
							<h4 class="text-sm sm:text-base font-semibold text-gray-800 mb-2 pl-1 border-l-3 border-green-500 pl-3">1.2 算法类型</h4>
							<div class="ml-4 sm:ml-6">
								<span class="inline-block px-3 sm:px-4 py-1.5 sm:py-2 bg-green-100 text-green-800 text-xs sm:text-sm font-medium rounded-full border border-green-200">
									生成合成类
								</span>
							</div>
						</div>

						<!-- 算法技术特性 -->
						<div>
							<h4 class="text-sm sm:text-base font-semibold text-gray-800 mb-2 pl-1 border-l-3 border-purple-500 pl-3">1.3 算法技术特性</h4>
							<div class="ml-4 sm:ml-6 space-y-3 sm:space-y-4">
								<div class="p-3 sm:p-4 bg-purple-50 rounded-lg border border-purple-100">
									<h5 class="text-xs sm:text-sm font-medium text-purple-800 mb-1">交互式多能型AI技术</h5>
									<p class="text-gray-700 text-xs sm:text-sm">
										基于生成式大模型技术、自然语言处理技术，通过海量文本的深度学习大模型预训练，具备撰写邮件、列举提纲、灵感写作、方案和建议回复等能力。
									</p>
								</div>
								<div class="p-3 sm:p-4 bg-blue-50 rounded-lg border border-blue-100">
									<h5 class="text-xs sm:text-sm font-medium text-blue-800 mb-1">多模态理解与生成</h5>
									<p class="text-gray-700 text-xs sm:text-sm">
										无需复杂的输入处理模块，可理解用户多样化需求，产出写诗、讲故事、编剧本、机器翻译、表格生成、代码写作等不同格式回复，延伸至图像处理&生成、语音处理&合成、办公文档处理等多模态任务。
									</p>
								</div>
							</div>
						</div>

						<!-- 算法运行机制 -->
						<div>
							<h4 class="text-sm sm:text-base font-semibold text-gray-800 mb-2 pl-1 border-l-3 border-amber-500 pl-3">1.4 算法运行机制</h4>
							<div class="ml-4 sm:ml-6">
								<div class="bg-gradient-to-r from-amber-50 to-amber-25 border border-amber-100 rounded-lg p-3 sm:p-4">
									<ol class="space-y-2 sm:space-y-3">
										<li class="flex items-start">
											<span class="flex-shrink-0 w-6 h-6 bg-amber-100 text-amber-800 rounded-full flex items-center justify-center text-xs sm:text-sm font-medium mr-3 mt-0.5">
												1
											</span>
											<span class="text-gray-700 text-xs sm:text-sm">用户给定文本、代码、图片、音频、视频或办公文档文件作为输入</span>
										</li>
										<li class="flex items-start">
											<span class="flex-shrink-0 w-6 h-6 bg-amber-100 text-amber-800 rounded-full flex items-center justify-center text-xs sm:text-sm font-medium mr-3 mt-0.5">
												2
											</span>
											<span class="text-gray-700 text-xs sm:text-sm">输入数据经过安全过滤判断是否通过安全筛选，若不通过则不进行数据生成，直接返回完整安全结果</span>
										</li>
										<li class="flex items-start">
											<span class="flex-shrink-0 w-6 h-6 bg-amber-100 text-amber-800 rounded-full flex items-center justify-center text-xs sm:text-sm font-medium mr-3 mt-0.5">
												3
											</span>
											<span class="text-gray-700 text-xs sm:text-sm">将各类模态输入内容送入预训练模型，根据用户指令生成对应模态的输出数据（文本、代码、图片、音频等）</span>
										</li>
										<li class="flex items-start">
											<span class="flex-shrink-0 w-6 h-6 bg-amber-100 text-amber-800 rounded-full flex items-center justify-center text-xs sm:text-sm font-medium mr-3 mt-0.5">
												4
											</span>
											<span class="text-gray-700 text-xs sm:text-sm">输出数据再次经过安全过滤筛选，通过则返回结果</span>
										</li>
										<li class="flex items-start">
											<span class="flex-shrink-0 w-6 h-6 bg-amber-100 text-amber-800 rounded-full flex items-center justify-center text-xs sm:text-sm font-medium mr-3 mt-0.5">
												5
											</span>
											<span class="text-gray-700 text-xs sm:text-sm">对生成结果进行后续处理（如图像修剪、缩放、分辨率调整等），输出该轮交互最终结果</span>
										</li>
										<li class="flex items-start">
											<span class="flex-shrink-0 w-6 h-6 bg-amber-100 text-amber-800 rounded-full flex items-center justify-center text-xs sm:text-sm font-medium mr-3 mt-0.5">
												6
											</span>
											<span class="text-gray-700 text-xs sm:text-sm">支持多轮交互，回到第1步循环执行</span>
										</li>
									</ol>
								</div>
							</div>
						</div>

						<!-- 算法应用场景 -->
						<div>
							<h4 class="text-sm sm:text-base font-semibold text-gray-800 mb-2 pl-1 border-l-3 border-indigo-500 pl-3">1.5 算法应用场景</h4>
							<div class="ml-4 sm:ml-6 space-y-3">
								<div class="p-3 sm:p-4 bg-indigo-50 rounded-lg border border-indigo-100 mb-3">
									<h5 class="text-xs sm:text-sm font-medium text-indigo-800 mb-1">核心应用场景</h5>
									<p class="text-gray-700 text-xs sm:text-sm">智能文本创作、机器翻译、表格生成、图像合成、语音合成、办公文档处理等。</p>
								</div>
								<div class="p-3 sm:p-4 bg-blue-50 rounded-lg border border-blue-100">
									<h5 class="text-xs sm:text-sm font-medium text-blue-800 mb-2">{{ APP_DISPLAY_NAME }}具体应用</h5>
									<div class="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3">
										<div class="bg-white p-2 sm:p-3 rounded border border-gray-100">
											<div class="flex items-center mb-1">
												<div class="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
												<span class="text-xs sm:text-sm font-medium text-gray-800">智能文本创作</span>
											</div>
											<p class="text-xs text-gray-600">公文起草、报告撰写、会议纪要生成</p>
										</div>
										<div class="bg-white p-2 sm:p-3 rounded border border-gray-100">
											<div class="flex items-center mb-1">
												<div class="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
												<span class="text-xs sm:text-sm font-medium text-gray-800">表格生成与处理</span>
											</div>
											<p class="text-xs text-gray-600">数据报表、统计表格自动生成</p>
										</div>
										<div class="bg-white p-2 sm:p-3 rounded border border-gray-100">
											<div class="flex items-center mb-1">
												<div class="w-2 h-2 bg-purple-500 rounded-full mr-2"></div>
												<span class="text-xs sm:text-sm font-medium text-gray-800">办公文档处理</span>
											</div>
											<p class="text-xs text-gray-600">文档格式转换、内容摘要、多格式支持</p>
										</div>
										<div class="bg-white p-2 sm:p-3 rounded border border-gray-100">
											<div class="flex items-center mb-1">
												<div class="w-2 h-2 bg-amber-500 rounded-full mr-2"></div>
												<span class="text-xs sm:text-sm font-medium text-gray-800">智能问答与咨询</span>
											</div>
											<p class="text-xs text-gray-600">政策解读、流程咨询、模板推荐</p>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- 算法目的意图 -->
						<div>
							<h4 class="text-sm sm:text-base font-semibold text-gray-800 mb-2 pl-1 border-l-3 border-red-500 pl-3">1.6 算法目的意图</h4>
							<div class="ml-4 sm:ml-6">
								<div class="p-3 sm:p-4 bg-gradient-to-r from-red-50 to-pink-50 rounded-lg border border-red-100">
									<p class="text-gray-700 text-xs sm:text-sm mb-3">
										通过文本指令调用预训练模型，产出写诗、讲故事、编剧本、机器翻译、表格生成、代码写作等不同格式的恰当回复，满足用户相关创作、办公、知识获取等需求；进一步可通过文本指令完成图像生成和语音合成，解决多模态任务场景需求；同时支持输入代码、图像、语音和办公文档并输出文本，实现代码辅助、看图说话、视觉问答、语音转文字、办公文档信息处理等目的。
									</p>
									<div class="p-3 bg-white rounded border border-gray-200">
										<p class="text-xs sm:text-sm font-medium text-gray-800 mb-1">{{ APP_DISPLAY_NAME }}核心目的：</p>
										<p class="text-xs sm:text-sm text-gray-700">提升公文处理效率和质量，为政府机构、企事业单位提供智能化办公解决方案，降低人工成本，提升工作效率。</p>
									</div>
								</div>
							</div>
						</div>

						<!-- 算法备案号 -->
						<div>
							<h4 class="text-sm sm:text-base font-semibold text-gray-800 mb-2 pl-1 border-l-3 border-blue-500 pl-3">1.7 算法备案号</h4>
							<div class="ml-4 sm:ml-6">
								<div class="p-3 sm:p-4 bg-gradient-to-r from-blue-50 to-blue-100 rounded-lg border border-blue-200">
									<div class="mb-3">
										<p class="text-xs sm:text-sm text-gray-600 mb-2">备案编号：</p>
										<div class="p-3 bg-white rounded border border-gray-200">
											<a
												href="https://beian.cac.gov.cn/#/index"
												target="_blank"
												rel="noopener noreferrer"
												class="text-blue-600 hover:text-blue-800 hover:underline font-medium inline-flex items-center"
											>
												<span class="text-sm sm:text-base">网信算备330110507206401230035号</span>
												<svg class="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
													<path
														stroke-linecap="round"
														stroke-linejoin="round"
														stroke-width="2"
														d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
													></path>
												</svg>
											</a>
										</div>
									</div>

									<div class="p-3 bg-white rounded border border-gray-200">
										<p class="text-xs sm:text-sm font-medium text-gray-800 mb-1">备案查询系统：</p>
										<p class="text-xs sm:text-sm text-gray-600 mb-2">国家互联网信息办公室算法备案系统</p>
										<a
											href="https://beian.cac.gov.cn/#/index"
											target="_blank"
											rel="noopener noreferrer"
											class="inline-flex items-center px-3 py-1.5 bg-blue-600 text-white text-xs sm:text-sm font-medium rounded hover:bg-blue-700 transition-colors"
										>
											<svg class="w-3 h-3 sm:w-4 sm:h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
												<path
													stroke-linecap="round"
													stroke-linejoin="round"
													stroke-width="2"
													d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
												></path>
											</svg>
											前往查询
										</a>
									</div>
								</div>
							</div>
						</div>

						<!-- 技术支持方 -->
						<div>
							<h4 class="text-sm sm:text-base font-semibold text-gray-800 mb-2 pl-1 border-l-3 border-gray-500 pl-3">1.8 算法备案单位</h4>
							<div class="ml-4 sm:ml-6">
								<div class="flex items-center p-3 sm:p-4 bg-gray-50 rounded-lg border border-gray-200">
									<div>
										<p class="text-sm sm:text-base font-medium text-gray-900">阿里巴巴达摩院(杭州)科技有限公司</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 用户权益保障 -->
			<div class="mb-8 sm:mb-12" v-if="false">
				<div class="flex items-center mb-4 sm:mb-6">
					<div class="w-1 h-8 sm:h-10 bg-green-600 rounded-full mr-3 sm:mr-4"></div>
					<h2 class="text-lg sm:text-xl md:text-2xl font-bold text-gray-900">二、用户权益保障</h2>
				</div>
				<div class="ml-4 sm:ml-6">
					<p class="text-gray-700 text-sm sm:text-base mb-4">在使用{{ APP_DISPLAY_NAME }}服务时，用户享有以下权益：</p>
					<div class="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
						<div class="bg-green-50 border border-green-100 rounded-lg p-3 sm:p-4">
							<div class="flex items-center mb-2">
								<div class="w-3 h-3 bg-green-500 rounded-full mr-2"></div>
								<h3 class="text-sm sm:text-base font-medium text-gray-800">算法基本原理与运行机制的知情权</h3>
							</div>
							<p class="text-xs sm:text-sm text-gray-600">了解算法如何工作、数据处理流程等基本信息</p>
						</div>
						<div class="bg-blue-50 border border-blue-100 rounded-lg p-3 sm:p-4">
							<div class="flex items-center mb-2">
								<div class="w-3 h-3 bg-blue-500 rounded-full mr-2"></div>
								<h3 class="text-sm sm:text-base font-medium text-gray-800">生成内容的审核权与修改权</h3>
							</div>
							<p class="text-xs sm:text-sm text-gray-600">有权审核、修改或拒绝算法生成的内容</p>
						</div>
						<div class="bg-purple-50 border border-purple-100 rounded-lg p-3 sm:p-4">
							<div class="flex items-center mb-2">
								<div class="w-3 h-3 bg-purple-500 rounded-full mr-2"></div>
								<h3 class="text-sm sm:text-base font-medium text-gray-800">个人信息和数据的安全保护权</h3>
							</div>
							<p class="text-xs sm:text-sm text-gray-600">个人数据受到安全保护，不被滥用或泄露</p>
						</div>
						<div class="bg-amber-50 border border-amber-100 rounded-lg p-3 sm:p-4">
							<div class="flex items-center mb-2">
								<div class="w-3 h-3 bg-amber-500 rounded-full mr-2"></div>
								<h3 class="text-sm sm:text-base font-medium text-gray-800">对算法服务的反馈与建议权</h3>
							</div>
							<p class="text-xs sm:text-sm text-gray-600">可随时提出使用反馈和功能建议</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { APP_DISPLAY_NAME } from '@/config/app'
</script>

<style scoped>
/* 响应式字体调整 */
.privacy-policy-body {
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

/* 移动端优化 */
@media (max-width: 640px) {
	.privacy-policy-body {
		padding: 1rem;
	}

	ol,
	ul {
		padding-left: 1rem;
	}
}

/* 打印优化 */
@media print {
	.privacy-policy {
		background: white !important;
	}

	.privacy-policy-body {
		box-shadow: none !important;
		border: 1px solid #ddd;
	}
}
</style>
